import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  useApproveInternalJobMutation,
  useDeleteInternalJobMutation,
  useGetInternalJobQuery,
  // useGetInternalJobsQuery, // This seems unused, can be removed
  useRejectInternalJobMutation,
} from '../../../../../../redux/services/fij_internal_jobs.jsx';
import { QuestionModal, Spinner } from '../../../../../common/index.jsx';
import FijJobDetail from '../../../../../common/FijInternalJobs/FijJobDetail.jsx';
import { routes } from '../../../../../../utils/helpers/ApiClient.jsx';
import { AppBarCMS } from '../../../../../basic/index.jsx';
import { useTranslation } from 'react-i18next';
import { useCreateInterestMutation } from '../../../../../../redux/services/fij_applications.jsx';
// This import seems incorrect and unused
// import { navigate } from 'react-big-calendar/lib/utils/constants';
import { DeleteFilled, EditOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { FIJ_JOB_STATUS } from '../../../../../../utils/constants/enums.js';
import { useToastMessages } from '../../../../../../hooks/useToastMessages.jsx';

const FijJobDetailPage = () => {
  const user = useSelector((state) => state.auth.user);
  const { id } = useParams();
  const navigate = useNavigate();
  const [rowToBeDeleted, setRowToBeDeleted] = useState(null);
  const { t } = useTranslation();

  const {
    saveSuccess,
    deleteSuccess: toastDeleteSuccess,
    successApproved,
    successRejected: successRejected,
  } = useToastMessages();

  const {
    data: internalJob,
    isLoading,
    refetch,
  } = useGetInternalJobQuery({ id, forDetail: true });

  const [createInterest, { isSuccess: isInterestMadeSuccess }] =
    useCreateInterestMutation();
  const [approveInternalJob, { isSuccess: isApproveSuccess }] =
    useApproveInternalJobMutation();
  const [rejectInternalJob, { isSuccess: isRejectSuccess }] =
    useRejectInternalJobMutation();
  const [deleteInternalJob, { isSuccess: isDeleteSuccess }] =
    useDeleteInternalJobMutation();

  const interestFormInitialValues = {
    mail: '',
    motivation_text: '',
  };

  const pageTitle = t('Detail FRI praxe');

  useEffect(() => {
    document.title = pageTitle + ' - FRI.prax';
  }, [pageTitle]); // Runs on mount

  useEffect(() => {
    if (isInterestMadeSuccess) {
      saveSuccess();
      navigate(routes.cmsFijJobListOfMyInterests);
    }
    if (isApproveSuccess) {
      successApproved();
      refetch();
    }
    if (isRejectSuccess) {
      successRejected();
      refetch();
    }
    if (isDeleteSuccess) {
      toastDeleteSuccess();
      navigate(routes.cmsFijJobs);
    }
  }, [
    isInterestMadeSuccess,
    isApproveSuccess,
    isRejectSuccess,
    isDeleteSuccess,
  ]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t(pageTitle)}
        backUrl={-1}
        backUrlTooltip={t('Zoznam aktuálnych FRI praxí')}
        secondaryActions={
          user && user.permissions['fri-internal-jobs-jobs.destroy']
            ? [
                ...(internalJob && internalJob.status === FIJ_JOB_STATUS.WAITING
                  ? [
                      {
                        url: `${routes.cmsFijJobEdit}/${id}`,
                        title: 'Upraviť',
                        icon: <EditOutlined />,
                      },
                    ]
                  : []),
                {
                  title: 'Vymazať',
                  onClick: () => setRowToBeDeleted(internalJob),
                  icon: <DeleteFilled />,
                },
              ]
            : []
        }
      />
      <div style={{ margin: '10px' }}>
        <FijJobDetail
          internalJob={internalJob}
          refetchInternalJobData={refetch}
          onSendInterestClick={(values) => {
            createInterest({ body: values, id: id });
          }}
          onApproveClick={() => {
            approveInternalJob(id);
          }}
          onRejectClick={() => {
            rejectInternalJob(id);
          }}
          interestFormInitialValues={interestFormInitialValues}
        />
      </div>

      <QuestionModal
        chosenPositive={() => deleteInternalJob(rowToBeDeleted.id)}
        question={t('Naozaj chcete vymazať túto položku?')}
        visible={rowToBeDeleted !== null}
        yes={t('Áno')}
        toggle={() => setRowToBeDeleted(null)}
        headerTitle={t('Vymazať položku')}
      />
    </>
  );
};

export default FijJobDetailPage;
